import { useEffect, useState } from 'react'

/**
 * Valor com atraso (debounce).
 *
 * O campo de busca das listas dispara consulta ao SERVIDOR. Sem atraso, digitar
 * "Fernanda" são oito requisições, sete delas descartadas — e, com rate limit
 * por IP ligado na API, é assim que o próprio operador se bloqueia sozinho.
 */
export function useValorAtrasado<T>(valor: T, milissegundos = 350): T {
  const [atrasado, setAtrasado] = useState(valor)

  useEffect(() => {
    const temporizador = window.setTimeout(() => {
      setAtrasado(valor)
    }, milissegundos)

    return () => {
      window.clearTimeout(temporizador)
    }
  }, [valor, milissegundos])

  return atrasado
}
